const { REACT_APP_API_HOST } = process.env

export const buildImageUrl = image => image ? image.includes(REACT_APP_API_HOST) ? image : `${REACT_APP_API_HOST}${image}` : ''
